import { render, staticRenderFns } from "./HeroesList.vue?vue&type=template&id=50d48024&"
import script from "./HeroesList.vue?vue&type=script&lang=js&"
export * from "./HeroesList.vue?vue&type=script&lang=js&"
import style0 from "./HeroesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports